/* A homepage-only view of the existing collection; never modifies its saved sort. */
if (!customElements.get('ctfa-home-new-designs')) {
  customElements.define('ctfa-home-new-designs', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.controller = new AbortController();
      this.load();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.started = false;
    }
    async load() {
      const grid = this.querySelector('[data-new-designs-grid]');
      const status = this.querySelector('[data-new-designs-status]');
      const cards = [];
      const seenProducts = new Set();
      const seenPages = new Set();
      let url = new URL(this.dataset.source, window.location.origin);
      const timeout = setTimeout(() => this.controller.abort(), 20000);
      try {
        while (url && cards.length < 8 && seenPages.size < 5) {
          if (url.origin !== window.location.origin) throw new Error('Invalid collection origin');
          url.searchParams.set('sort_by', 'created-descending');
          url.searchParams.set('section_id', 'ctfa-home-new-designs');
          if (seenPages.has(url.href)) throw new Error('Repeated collection page');
          seenPages.add(url.href);
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error('Unable to load new designs');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fragment = documentFragment.querySelector('[data-new-designs-fragment]');
          if (!fragment) throw new Error('Missing new-designs fragment');
          for (const card of fragment.querySelectorAll('[data-new-design-card]')) {
            if (seenProducts.has(card.dataset.productId)) continue;
            seenProducts.add(card.dataset.productId);
            cards.push(card);
            if (cards.length === 8) break;
          }
          url = fragment.dataset.next ? new URL(fragment.dataset.next, url) : null;
        }
        if (!this.isConnected) return;
        grid.replaceChildren(...cards);
        status.textContent = cards.length === 8 ? '' : 'Showing the newest eligible designs available here. Browse all designs above for more.';
        status.hidden = cards.length === 8;
      } catch (error) {
        if (!this.isConnected) return;
        status.textContent = 'New designs could not load. Please use Browse all designs above to see the collection.';
      } finally {
        clearTimeout(timeout);
        if (this.isConnected) grid.setAttribute('aria-busy', 'false');
      }
    }
  });
}
